import { render, staticRenderFns } from "./materialDistribute.vue?vue&type=template&id=051bf8b1&"
import script from "./materialDistribute.vue?vue&type=script&lang=js&"
export * from "./materialDistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports